import React, {h} from "preact";
import {Card, FR} from "../../../_common/layout";
import Badge from "../../../_common/components/Badge";
import {ButtonGhost} from "../../../_common/components/buttons/buttons";
import {t} from "../../../_i18n";
import {useHistory} from "react-router-dom";
import {connect} from "react-redux";
import {setExamSelected} from "../../../_rx/enrollment/exams/actions";

function CardUpcomingExamView({event, setExamSelected, isNextTerm}) {
    const history = useHistory()
    const handleClick = () => {
        history.push(`/examenes/apply`)
        setExamSelected(event)
    }

    return (
        <Card className='m-top' smOnly={false}>
            <div className='d-flex flex-space-between flex-column sm-no-flex-column'>
                <div className='sm-col-70'>
                    <div className='t-upper font-color-879CA1 font-14'>{event.formative_action_code}</div>
                    <div className='font-20 m-top-half'>{event.formative_action_title}</div>
                    {!isNextTerm && <Badge type='warning' className='m-top-half'>{event.exam_convocation_name}</Badge>}
                </div>
                <div className='sm-col-30 d-flex flex-center-y m-top sm-no-m-top'>
                    {event.has_exam_credit && <ButtonGhost className='t-upper full-width'
                                                           onClick={handleClick}>{t('Reservar Plaza')}</ButtonGhost>}
                </div>
            </div>
            {!event.has_exam_credit &&
                <div>
                    <hr className='separator-xxs'/>
                    {event.can_buy_credit
                        ? <FR>
                            <div className="sm-col-55 col-100 font-14"
                                 dangerouslySetInnerHTML={{__html: t('exams_credit_text')}}/>
                            {event.cart_url &&
                                <div className="sm-col-45 col-100 d-flex flex-right"><a href={event.cart_url}
                                                                                        target='_blank'
                                                                                        className='btn btn-primary sm-fit-width full-width font-color-white t-upper'>{t('Comprar derechos de examen')}</a>
                                </div>}
                        </FR>
                        : event.is_last_credit &&
                        <div className='font-14' dangerouslySetInnerHTML={{__html: t('exams_no_credits')}}/>
                    }
                </div>
            }
        </Card>
    )
}

CardUpcomingExamView = connect(
    ({}) => ({}),
    {setExamSelected})(CardUpcomingExamView);


export default ({...rest}) => {
    return (<CardUpcomingExamView {...rest} />);
}
